import { __read } from "tslib";
var weirdNewlines = /(\u000D|\u000C|\u000D\u000A)/g;
var nullOrSurrogates = /[\u0000\uD800-\uDFFF]/g;
var commentRegex = /(\/\*)[\s\S]*?(\*\/)/g;
export var lexicalAnalysis = function (str, index) {
    if (index === void 0) { index = 0; }
    str = str.replace(weirdNewlines, '\n').replace(nullOrSurrogates, '\uFFFD');
    str = str.replace(commentRegex, '');
    var tokens = [];
    for (; index < str.length; index += 1) {
        var code = str.charCodeAt(index);
        if (code === 0x0009 || code === 0x0020 || code === 0x000a) {
            var code_1 = str.charCodeAt(++index);
            while (code_1 === 0x0009 || code_1 === 0x0020 || code_1 === 0x000a) {
                code_1 = str.charCodeAt(++index);
            }
            index -= 1;
            tokens.push({
                type: '<whitespace-token>'
            });
        }
        else if (code === 0x0022) {
            var result = consumeString(str, index);
            if (result === null) {
                return null;
            }
            var _a = __read(result, 2), lastIndex = _a[0], value = _a[1];
            tokens.push({
                type: '<string-token>',
                value: value
            });
            index = lastIndex;
        }
        else if (code === 0x0023) {
            if (index + 1 < str.length) {
                var nextCode = str.charCodeAt(index + 1);
                if (nextCode === 0x005f ||
                    (nextCode >= 0x0041 && nextCode <= 0x005a) ||
                    (nextCode >= 0x0061 && nextCode <= 0x007a) ||
                    nextCode >= 0x0080 ||
                    (nextCode >= 0x0030 && nextCode <= 0x0039) ||
                    (nextCode === 0x005c &&
                        index + 2 < str.length &&
                        str.charCodeAt(index + 2) !== 0x000a)) {
                    var flag = wouldStartIdentifier(str, index + 1)
                        ? 'id'
                        : 'unrestricted';
                    var result = consumeIdentUnsafe(str, index + 1);
                    if (result !== null) {
                        var _b = __read(result, 2), lastIndex = _b[0], value = _b[1];
                        tokens.push({
                            type: '<hash-token>',
                            value: value.toLowerCase(),
                            flag: flag
                        });
                        index = lastIndex;
                        continue;
                    }
                }
            }
            tokens.push({ type: '<delim-token>', value: code });
        }
        else if (code === 0x0027) {
            var result = consumeString(str, index);
            if (result === null) {
                return null;
            }
            var _c = __read(result, 2), lastIndex = _c[0], value = _c[1];
            tokens.push({
                type: '<string-token>',
                value: value
            });
            index = lastIndex;
        }
        else if (code === 0x0028) {
            tokens.push({ type: '<(-token>' });
        }
        else if (code === 0x0029) {
            tokens.push({ type: '<)-token>' });
        }
        else if (code === 0x002b) {
            var plusNumeric = consumeNumeric(str, index);
            if (plusNumeric === null) {
                tokens.push({
                    type: '<delim-token>',
                    value: code
                });
            }
            else {
                var _d = __read(plusNumeric, 2), lastIndex = _d[0], tokenTuple = _d[1];
                if (tokenTuple[0] === '<dimension-token>') {
                    tokens.push({
                        type: '<dimension-token>',
                        value: tokenTuple[1],
                        unit: tokenTuple[2].toLowerCase(),
                        flag: 'number'
                    });
                }
                else if (tokenTuple[0] === '<number-token>') {
                    tokens.push({
                        type: tokenTuple[0],
                        value: tokenTuple[1],
                        flag: tokenTuple[2]
                    });
                }
                else {
                    tokens.push({
                        type: tokenTuple[0],
                        value: tokenTuple[1],
                        flag: 'number'
                    });
                }
                index = lastIndex;
            }
        }
        else if (code === 0x002c) {
            tokens.push({ type: '<comma-token>' });
        }
        else if (code === 0x002d) {
            var minusNumeric = consumeNumeric(str, index);
            if (minusNumeric !== null) {
                var _e = __read(minusNumeric, 2), lastIndex = _e[0], tokenTuple = _e[1];
                if (tokenTuple[0] === '<dimension-token>') {
                    tokens.push({
                        type: '<dimension-token>',
                        value: tokenTuple[1],
                        unit: tokenTuple[2].toLowerCase(),
                        flag: 'number'
                    });
                }
                else if (tokenTuple[0] === '<number-token>') {
                    tokens.push({
                        type: tokenTuple[0],
                        value: tokenTuple[1],
                        flag: tokenTuple[2]
                    });
                }
                else {
                    tokens.push({
                        type: tokenTuple[0],
                        value: tokenTuple[1],
                        flag: 'number'
                    });
                }
                index = lastIndex;
                continue;
            }
            if (index + 2 < str.length) {
                var nextCode = str.charCodeAt(index + 1);
                var nextNextCode = str.charCodeAt(index + 2);
                if (nextCode === 0x002d && nextNextCode === 0x003e) {
                    tokens.push({
                        type: '<CDC-token>'
                    });
                    index += 2;
                    continue;
                }
            }
            var result = consumeIdentLike(str, index);
            if (result !== null) {
                var _f = __read(result, 3), lastIndex = _f[0], value = _f[1], type = _f[2];
                tokens.push({
                    type: type,
                    value: value
                });
                index = lastIndex;
                continue;
            }
            tokens.push({
                type: '<delim-token>',
                value: code
            });
        }
        else if (code === 0x002e) {
            var minusNumeric = consumeNumeric(str, index);
            if (minusNumeric === null) {
                tokens.push({
                    type: '<delim-token>',
                    value: code
                });
            }
            else {
                var _g = __read(minusNumeric, 2), lastIndex = _g[0], tokenTuple = _g[1];
                if (tokenTuple[0] === '<dimension-token>') {
                    tokens.push({
                        type: '<dimension-token>',
                        value: tokenTuple[1],
                        unit: tokenTuple[2].toLowerCase(),
                        flag: 'number'
                    });
                }
                else if (tokenTuple[0] === '<number-token>') {
                    tokens.push({
                        type: tokenTuple[0],
                        value: tokenTuple[1],
                        flag: tokenTuple[2]
                    });
                }
                else {
                    tokens.push({
                        type: tokenTuple[0],
                        value: tokenTuple[1],
                        flag: 'number'
                    });
                }
                index = lastIndex;
                continue;
            }
        }
        else if (code === 0x003a) {
            tokens.push({ type: '<colon-token>' });
        }
        else if (code === 0x003b) {
            tokens.push({ type: '<semicolon-token>' });
        }
        else if (code === 0x003c) {
            if (index + 3 < str.length) {
                var nextCode = str.charCodeAt(index + 1);
                var nextNextCode = str.charCodeAt(index + 2);
                var nextNextNextCode = str.charCodeAt(index + 3);
                if (nextCode === 0x0021 &&
                    nextNextCode === 0x002d &&
                    nextNextNextCode === 0x002d) {
                    tokens.push({
                        type: '<CDO-token>'
                    });
                    index += 3;
                    continue;
                }
            }
            tokens.push({
                type: '<delim-token>',
                value: code
            });
        }
        else if (code === 0x0040) {
            var result = consumeIdent(str, index + 1);
            if (result !== null) {
                var _h = __read(result, 2), lastIndex = _h[0], value = _h[1];
                tokens.push({
                    type: '<at-keyword-token>',
                    value: value.toLowerCase()
                });
                index = lastIndex;
                continue;
            }
            tokens.push({ type: '<delim-token>', value: code });
        }
        else if (code === 0x005b) {
            tokens.push({ type: '<[-token>' });
        }
        else if (code === 0x005c) {
            var result = consumeEscape(str, index);
            if (result === null) {
                return null;
            }
            var _j = __read(result, 2), lastIndex = _j[0], value = _j[1];
            str = str.slice(0, index) + value + str.slice(lastIndex + 1);
            index -= 1;
        }
        else if (code === 0x005d) {
            tokens.push({ type: '<]-token>' });
        }
        else if (code === 0x007b) {
            tokens.push({ type: '<{-token>' });
        }
        else if (code === 0x007d) {
            tokens.push({ type: '<}-token>' });
        }
        else if (code >= 0x0030 && code <= 0x0039) {
            var result = consumeNumeric(str, index);
            var _k = __read(result, 2), lastIndex = _k[0], tokenTuple = _k[1];
            if (tokenTuple[0] === '<dimension-token>') {
                tokens.push({
                    type: '<dimension-token>',
                    value: tokenTuple[1],
                    unit: tokenTuple[2].toLowerCase(),
                    flag: 'number'
                });
            }
            else if (tokenTuple[0] === '<number-token>') {
                tokens.push({
                    type: tokenTuple[0],
                    value: tokenTuple[1],
                    flag: tokenTuple[2]
                });
            }
            else {
                tokens.push({
                    type: tokenTuple[0],
                    value: tokenTuple[1],
                    flag: 'number'
                });
            }
            index = lastIndex;
        }
        else if (code === 0x005f ||
            (code >= 0x0041 && code <= 0x005a) ||
            (code >= 0x0061 && code <= 0x007a) ||
            code >= 0x0080) {
            var result = consumeIdentLike(str, index);
            if (result === null) {
                return null;
            }
            var _l = __read(result, 3), lastIndex = _l[0], value = _l[1], type = _l[2];
            tokens.push({
                type: type,
                value: value
            });
            index = lastIndex;
        }
        else {
            tokens.push({ type: '<delim-token>', value: code });
        }
    }
    tokens.push({ type: '<EOF-token>' });
    return tokens;
};
export var consumeString = function (str, index) {
    if (str.length <= index + 1)
        return null;
    var firstCode = str.charCodeAt(index);
    var charCodes = [];
    for (var i = index + 1; i < str.length; i += 1) {
        var code = str.charCodeAt(i);
        if (code === firstCode) {
            return [i, String.fromCharCode.apply(null, charCodes)];
        }
        else if (code === 0x005c) {
            var result = consumeEscape(str, i);
            if (result === null)
                return null;
            var _a = __read(result, 2), lastIndex = _a[0], charCode = _a[1];
            charCodes.push(charCode);
            i = lastIndex;
        }
        else if (code === 0x000a) {
            return null;
        }
        else {
            charCodes.push(code);
        }
    }
    return null;
};
export var wouldStartIdentifier = function (str, index) {
    if (str.length <= index)
        return false;
    var code = str.charCodeAt(index);
    if (code === 0x002d) {
        if (str.length <= index + 1)
            return false;
        var nextCode = str.charCodeAt(index + 1);
        if (nextCode === 0x002d ||
            nextCode === 0x005f ||
            (nextCode >= 0x0041 && nextCode <= 0x005a) ||
            (nextCode >= 0x0061 && nextCode <= 0x007a) ||
            nextCode >= 0x0080) {
            return true;
        }
        else if (nextCode === 0x005c) {
            if (str.length <= index + 2)
                return false;
            var nextNextCode = str.charCodeAt(index + 2);
            return nextNextCode !== 0x000a;
        }
        else {
            return false;
        }
    }
    else if (code === 0x005f ||
        (code >= 0x0041 && code <= 0x005a) ||
        (code >= 0x0061 && code <= 0x007a) ||
        code >= 0x0080) {
        return true;
    }
    else if (code === 0x005c) {
        if (str.length <= index + 1)
            return false;
        var nextCode = str.charCodeAt(index + 1);
        return nextCode !== 0x000a;
    }
    else {
        return false;
    }
};
export var consumeEscape = function (str, index) {
    if (str.length <= index + 1)
        return null;
    if (str.charCodeAt(index) !== 0x005c)
        return null;
    var code = str.charCodeAt(index + 1);
    if (code === 0x000a) {
        return null;
    }
    else if ((code >= 0x0030 && code <= 0x0039) ||
        (code >= 0x0041 && code <= 0x0046) ||
        (code >= 0x0061 && code <= 0x0066)) {
        var hexCharCodes = [code];
        var min = Math.min(index + 7, str.length);
        var i = index + 2;
        for (; i < min; i += 1) {
            var code_2 = str.charCodeAt(i);
            if ((code_2 >= 0x0030 && code_2 <= 0x0039) ||
                (code_2 >= 0x0041 && code_2 <= 0x0046) ||
                (code_2 >= 0x0061 && code_2 <= 0x0066)) {
                hexCharCodes.push(code_2);
            }
            else {
                break;
            }
        }
        if (i < str.length) {
            var code_3 = str.charCodeAt(i);
            if (code_3 === 0x0009 || code_3 === 0x0020 || code_3 === 0x000a) {
                i += 1;
            }
        }
        return [i - 1, parseInt(String.fromCharCode.apply(null, hexCharCodes), 16)];
    }
    else {
        return [index + 1, code];
    }
};
export var consumeNumeric = function (str, index) {
    var numberResult = consumeNumber(str, index);
    if (numberResult === null)
        return null;
    var _a = __read(numberResult, 3), numberEndIndex = _a[0], numberValue = _a[1], numberFlag = _a[2];
    var identResult = consumeIdent(str, numberEndIndex + 1);
    if (identResult !== null) {
        var _b = __read(identResult, 2), identEndIndex = _b[0], identValue = _b[1];
        return [identEndIndex, ['<dimension-token>', numberValue, identValue]];
    }
    if (numberEndIndex + 1 < str.length &&
        str.charCodeAt(numberEndIndex + 1) === 0x0025) {
        return [numberEndIndex + 1, ['<percentage-token>', numberValue]];
    }
    return [numberEndIndex, ['<number-token>', numberValue, numberFlag]];
};
export var consumeNumber = function (str, index) {
    if (str.length <= index)
        return null;
    var flag = 'integer';
    var numberChars = [];
    var firstCode = str.charCodeAt(index);
    if (firstCode === 0x002b || firstCode === 0x002d) {
        index += 1;
        if (firstCode === 0x002d)
            numberChars.push(0x002d);
    }
    while (index < str.length) {
        var code = str.charCodeAt(index);
        if (code >= 0x0030 && code <= 0x0039) {
            numberChars.push(code);
            index += 1;
        }
        else {
            break;
        }
    }
    if (index + 1 < str.length) {
        var nextCode = str.charCodeAt(index);
        var nextNextCode = str.charCodeAt(index + 1);
        if (nextCode === 0x002e &&
            nextNextCode >= 0x0030 &&
            nextNextCode <= 0x0039) {
            numberChars.push(nextCode, nextNextCode);
            flag = 'number';
            index += 2;
            while (index < str.length) {
                var code = str.charCodeAt(index);
                if (code >= 0x0030 && code <= 0x0039) {
                    numberChars.push(code);
                    index += 1;
                }
                else {
                    break;
                }
            }
        }
    }
    if (index + 1 < str.length) {
        var nextCode = str.charCodeAt(index);
        var nextNextCode = str.charCodeAt(index + 1);
        var nextNextNextCode = str.charCodeAt(index + 2);
        if (nextCode === 0x0045 || nextCode === 0x0065) {
            var nextNextIsDigit = nextNextCode >= 0x0030 && nextNextCode <= 0x0039;
            if (nextNextIsDigit ||
                ((nextNextCode === 0x002b || nextNextCode === 0x002d) &&
                    nextNextNextCode >= 0x0030 &&
                    nextNextNextCode <= 0x0039)) {
                flag = 'number';
                if (nextNextIsDigit) {
                    numberChars.push(0x0045, nextNextCode);
                    index += 2;
                }
                else if (nextNextCode === 0x002d) {
                    numberChars.push(0x0045, 0x002d, nextNextNextCode);
                    index += 3;
                }
                else {
                    numberChars.push(0x0045, nextNextNextCode);
                    index += 3;
                }
                while (index < str.length) {
                    var code = str.charCodeAt(index);
                    if (code >= 0x0030 && code <= 0x0039) {
                        numberChars.push(code);
                        index += 1;
                    }
                    else {
                        break;
                    }
                }
            }
        }
    }
    var numberString = String.fromCharCode.apply(null, numberChars);
    var value = flag === 'number' ? parseFloat(numberString) : parseInt(numberString);
    if (value === -0)
        value = 0;
    return Number.isNaN(value) ? null : [index - 1, value, flag];
};
export var consumeIdentUnsafe = function (str, index) {
    if (str.length <= index) {
        return null;
    }
    var identChars = [];
    for (var code = str.charCodeAt(index); index < str.length; code = str.charCodeAt(++index)) {
        if (code === 0x002d ||
            code === 0x005f ||
            (code >= 0x0041 && code <= 0x005a) ||
            (code >= 0x0061 && code <= 0x007a) ||
            code >= 0x0080 ||
            (code >= 0x0030 && code <= 0x0039)) {
            identChars.push(code);
            continue;
        }
        else {
            var result = consumeEscape(str, index);
            if (result !== null) {
                var _a = __read(result, 2), lastIndex = _a[0], code_4 = _a[1];
                identChars.push(code_4);
                index = lastIndex;
                continue;
            }
        }
        break;
    }
    return index === 0
        ? null
        : [index - 1, String.fromCharCode.apply(null, identChars)];
};
export var consumeIdent = function (str, index) {
    if (str.length <= index || !wouldStartIdentifier(str, index)) {
        return null;
    }
    var identChars = [];
    for (var code = str.charCodeAt(index); index < str.length; code = str.charCodeAt(++index)) {
        if (code === 0x002d ||
            code === 0x005f ||
            (code >= 0x0041 && code <= 0x005a) ||
            (code >= 0x0061 && code <= 0x007a) ||
            code >= 0x0080 ||
            (code >= 0x0030 && code <= 0x0039)) {
            identChars.push(code);
            continue;
        }
        else {
            var result = consumeEscape(str, index);
            if (result !== null) {
                var _a = __read(result, 2), lastIndex = _a[0], code_5 = _a[1];
                identChars.push(code_5);
                index = lastIndex;
                continue;
            }
        }
        break;
    }
    return [index - 1, String.fromCharCode.apply(null, identChars)];
};
export var consumeUrl = function (str, index) {
    var code = str.charCodeAt(index);
    while (code === 0x0009 || code === 0x0020 || code === 0x000a) {
        code = str.charCodeAt(++index);
    }
    var urlChars = [];
    var hasFinishedWord = false;
    while (index < str.length) {
        if (code === 0x0029) {
            return [index, String.fromCharCode.apply(null, urlChars)];
        }
        else if (code === 0x0022 || code === 0x0027 || code === 0x0028) {
            return null;
        }
        else if (code === 0x0009 || code === 0x0020 || code === 0x000a) {
            if (!hasFinishedWord && urlChars.length !== 0)
                hasFinishedWord = true;
        }
        else if (code === 0x005c) {
            var result = consumeEscape(str, index);
            if (result === null || hasFinishedWord)
                return null;
            var _a = __read(result, 2), lastIndex = _a[0], value = _a[1];
            urlChars.push(value);
            index = lastIndex;
        }
        else {
            if (hasFinishedWord)
                return null;
            urlChars.push(code);
        }
        code = str.charCodeAt(++index);
    }
    return null;
};
export var consumeIdentLike = function (str, index) {
    var result = consumeIdent(str, index);
    if (result === null)
        return null;
    var _a = __read(result, 2), lastIndex = _a[0], value = _a[1];
    if (value.toLowerCase() === 'url') {
        if (str.length > lastIndex + 1) {
            var nextCode = str.charCodeAt(lastIndex + 1);
            if (nextCode === 0x0028) {
                for (var offset = 2; lastIndex + offset < str.length; offset += 1) {
                    var nextNextCode = str.charCodeAt(lastIndex + offset);
                    if (nextNextCode === 0x0022 || nextNextCode === 0x0027) {
                        return [lastIndex + 1, value.toLowerCase(), '<function-token>'];
                    }
                    else if (nextNextCode !== 0x0009 &&
                        nextNextCode !== 0x0020 &&
                        nextNextCode !== 0x000a) {
                        var result_1 = consumeUrl(str, lastIndex + offset);
                        if (result_1 === null)
                            return null;
                        var _b = __read(result_1, 2), lastUrlIndex = _b[0], value_1 = _b[1];
                        return [lastUrlIndex, value_1, '<url-token>'];
                    }
                }
                return [lastIndex + 1, value.toLowerCase(), '<function-token>'];
            }
        }
    }
    else if (str.length > lastIndex + 1) {
        var nextCode = str.charCodeAt(lastIndex + 1);
        if (nextCode === 0x0028) {
            return [lastIndex + 1, value.toLowerCase(), '<function-token>'];
        }
    }
    return [lastIndex, value.toLowerCase(), '<ident-token>'];
};
//# sourceMappingURL=lexicalAnalysis.js.map